import React from "react";
import { useTranslation } from "react-i18next";
import DocumentPreviewContent from "../../containers/preview-document/DocumentPreviewContent.container.jsx";

const DocumentPreview = () => {
  
  const { t } = useTranslation();
  
  return (
    <>
      <DocumentPreviewContent t={t} />
    </>
  );
};

export default DocumentPreview;
